import { apiUrl } from "../../../utils/api";
import { apiBasePath } from "../../BasicUrl";

const UserData = apiBasePath.injectEndpoints({
    endpoints: (build) => ({
        getUseListApi: build.query({
            query: () => ({
                url: `${apiUrl.userList}`,
                method: "GET",
            }),
        }),
        getUseDetailtApi: build.query({
            query: (id) => ({
                url: `${apiUrl.userDetails}?id=${id}`,
                method: "GET",
            }),
        }),
        userSearchApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.userSearch}`,
                method: "POST",
                body: data,
            })
        }),
        userOrdersApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.userOrders}`,
                method: "POST",
                body: data
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetUseListApiQuery, useGetUseDetailtApiQuery, useUserOrdersApiMutation, useUserSearchApiMutation } = UserData;